import { NgClass } from '@angular/common';
import { Component, HostListener, input, OnDestroy, output } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
import { toObservable } from '@angular/core/rxjs-interop';
import { CopyButtonComponent } from "../copy-button/copy-button.component";

@Component({
  selector: 'app-notify',
  imports: [NgClass, SvgIconComponent, CopyButtonComponent],
  templateUrl: './notify.component.html',
  styleUrls: ['notify.component.css']
})
export class NotifyComponent implements OnDestroy {

  icon = input<string>()     // имя иконки
  color = input<'default' | 'success' | 'error'>('default')
  showClose = input(true)    // показывать кнопку Закрыть
  expire = input(5000)       // время жизни уведомления
  copyData = input<unknown>()  // данные для копирования

  closeElement  = output()
  expireElement = output()

  private paused = false
  private expireMs = 0
  private timerSub?: Subscription

  private expireSub = toObservable(this.expire).subscribe(expire => {
    this.expireMs = expire ?? 0
    if (this.expireMs <= 0) {
      this.stopTimer()
      return
    }
    if (!this.paused) {
      this.startTimer()
    }
  })

  @HostListener('mouseenter')
  protected pauseExpire() {
    if (this.paused) {
      return
    }
    this.paused = true
    this.stopTimer()
  }

  @HostListener('mouseleave')
  protected resumeExpire() {
    if (!this.paused) {
      return
    }
    this.paused = false
    if (this.expireMs <= 0) {
      return
    }
    this.startTimer()
  }

  private startTimer() {
    this.stopTimer()
    this.timerSub = timer(this.expireMs).subscribe(() => this.expireElement.emit())
  }

  private stopTimer() {
    if (this.timerSub) {
      this.timerSub.unsubscribe()
      this.timerSub = undefined
    }
  }

  ngOnDestroy() {
    this.stopTimer()
    this.expireSub?.unsubscribe()
  }

}
